import React from 'react';

interface Props {
    transparent?: boolean;
    circle?: boolean;
    text?: string;
    icon?: JSX.Element;
}

const MultistorePlaceCardBadge = ({text, icon, transparent, circle}: Props) => {
    if (!text && !icon) return <></>;

    return (
        <div
            className={`place-card-badge ${transparent ? "place-card-badge-dark" : ""} ${circle ? "place-card-badge-circle" : ""}`}>
            {icon}
            {text && <p className="mb-0">{text}</p>}
        </div>
    )
}

export default MultistorePlaceCardBadge;